module.exports = [{"source":"/showroom","destination":"/work","permanent":true},{"source":"/privacy-policy","destination":"/privacy","permanent":true}];